import { render } from "./streamfutures.vue?vue&type=template&id=72997605&ts=true"
import script from "./streamfutures.vue?vue&type=script&lang=ts"
export * from "./streamfutures.vue?vue&type=script&lang=ts"

import "./streamfutures.vue?vue&type=style&index=0&id=72997605&lang=css"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__